import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import UpdateStatusGroup from './UpdateStatusGroup'
import * as promotionActions from './../../../../../../actions/promotionAction';

const mapStateToProps = state => {
    return {
        promotionState: state.promotionReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        importStatusGroup: (file) => dispatch(promotionActions.importFile(file)),
        handleUpdateStatusGroup: (data) => dispatch(promotionActions.updateStatusGroup(data)),
        getSampleFileStatus: () => dispatch(promotionActions.getSampleFileStatus())
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(UpdateStatusGroup));